import React from 'react'
import "./Welcome.css";
import { Button } from '@mui/material';

function Welcome() {
  return (
 
          <div className="welcome">
            <div className="wc-container">
                <img src="https://media.licdn.com/dms/image/D4D03AQGrTunMEJkM7Q/profile-displayphoto-shrink_100_100/0/1667291105282?e=1698278400&v=beta&t=yNEM-PE0HQKBwkVZvCeiaVEdXRX0yTi1ZKVOkELoNAI"
                alt=""/>
                <h2>Welcome to WhatsApp Clone</h2>
                <p>Created with MERN stack</p>
                <p> By Himanshu Kumar</p>
                <ul>
                    <li>Google Sign-in</li>
                    <li>Create room</li>
                    <li>Search rooms</li>
                    <li>Chat with people</li>
                </ul>

            </div>
        </div>

  )
}

export default Welcome